module.exports = __webpack_public_path__ + "static/media/about-strength-carousel-1.6b2cfe7e.jpg";